// extracted by mini-css-extract-plugin
export default {"button":"jk-z","reviewSort":"kk-z"};